import axios from 'axios'

import { getApiServerBeUrl } from 'utils/env'

export const establishPlatformSession = async (email: string, password: string): Promise<void> => {
  await axios.post(
    `${getApiServerBeUrl()}/auth`,
    {},
    {
      auth: { username: email.trim(), password },
      withCredentials: true
    }
  )
}
